import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** calendar with a marked day. Decorative line icon; always pair with a visible text label. */
export function TodayIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <rect x="3.5" y="5" width="17" height="16" rx="3" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <path d="M3.5 10h17" />
      <circle cx="12" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
    </IconSvg>
  )
}
